export interface IdSequence {
  id: string;
  sequence: number;
}
